module.exports = __webpack_public_path__ + "img/2.36610e23.jpg";